import { axiosInstance, baseUrl, handleErrors } from "./auth";

// Answers a client submitted with an event booking, by the registrationFillFormId stored on the booking
export const GET_REGISTRATION_RESPONSE = async (registrationResponseId) => {
    try {
        const response = await axiosInstance.get(`${baseUrl}/vendor/registrationResponse/${registrationResponseId}`);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

// Registration Form Add
export const ADD_REGISTRATION_FORM = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/vendor/registrationForm/add`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

// Registration Form Edit
export const EDIT_REGISTRATION_FORM = async (params) => {
    try {
        const response = await axiosInstance.put(`${baseUrl}/vendor/registrationForm/update`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

// Registration Form Delete
export const DELETE_REGISTRATION_FORM = async (params) => {
    try {
        const response = await axiosInstance.put(`${baseUrl}/vendor/registrationForm/delete`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

// Registration Form List
export const REGISTRATION_FORM_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseUrl}/vendor/registrationForm/list`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};

// Registration Form Details
export const REGISTRATION_FORM_DETAILS = async (id) => {
    try {
        const response = await axiosInstance.get(`${baseUrl}/vendor/registrationForm/${id}`);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
